import { useQuery } from "react-query";
import _isEmpty from "lodash/isEmpty";
import {
  GET_GAME_CONFIG,
  TOURNAMENT_LIST_PUBLIC,
  TOURNAMENTS_LIST,
} from "../appConstants/APIEndpoint";
import { requestApiGet, requestApiPost } from "./index";
import type { IToken, PreSignUpConfig } from "../storage/store";
import { onPreSignupSuccess } from "../services/AuthService";
import {
  TournamentData,
  TournamentsConfig,
  Widget,
} from "../interfaces/TournamentsConfig";
import { useTokenStore } from "../storage/tokenState";
import { useMemo } from "react";
import { GameConfigResponseTypes, GameConfigs } from "../interfaces/GameConfig";

// Private function to get game config
export const getGameConfig = async (userToken: IToken): Promise<GameConfigs | null> => {
  try {
    const { accessToken, _id } = userToken;
    const params = { gameName: "ludonx" };
    const headers = { Authorization: accessToken, ludoUserId: _id };
    const config = { headers, params };

    const res = await requestApiGet<GameConfigs>(GET_GAME_CONFIG, config);
    const response = res?.response;

    if (response?.success) {
      return response?.data ?? null;
    } else {
      console.error("Failed to get game config:", response?.error);
      return null;
    }
  } catch (error) {
    console.error("Error fetching game config:", error);
    return null;
  }
};

export const useGetGameConfigAPI = (shouldFetch: boolean = false) => {

  const { token: userToken } = useTokenStore();
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ["getGameConfig", userToken?._id],
    queryFn: () => getGameConfig(userToken),
    enabled: !_isEmpty(userToken) && shouldFetch, // Only run if we have token AND shouldFetch is true
    refetchOnWindowFocus: false
  });

  const gameConfig = useMemo(() => data as unknown as GameConfigResponseTypes, [data]);

  return {
    gameConfig,
    isLoading,
    error,
    refetch,
  };
};
